import { render, staticRenderFns } from "./DataEditionIndividuals.vue?vue&type=template&id=766bab6e&"
import script from "./DataEditionIndividuals.vue?vue&type=script&lang=js&"
export * from "./DataEditionIndividuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports